import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_RENTAL_PACKAGE_SETUPS_REQUEST = 'FETCH_RENTAL_PACKAGE_SETUPS_REQUEST';
export const FETCH_RENTAL_PACKAGE_SETUPS_SUCCESS = 'FETCH_RENTAL_PACKAGE_SETUPS_SUCCESS';
export const FETCH_RENTAL_PACKAGE_SETUPS_ERROR = 'FETCH_RENTAL_PACKAGE_SETUPS_ERROR';

export const FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST =
  'FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST';
export const FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS =
  'FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS';
export const FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR =
  'FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR';

export const FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST =
  'FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST';
export const FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS =
  'FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS';
export const FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR =
  'FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR';

export const GET_RENTAL_PACKAGE_SETUP_DETAIL_REQUEST =
  'GET_RENTAL_PACKAGE_SETUP_DETAIL_REQUEST';
export const GET_RENTAL_PACKAGE_SETUP_DETAIL_SUCCESS =
  'GET_RENTAL_PACKAGE_SETUP_DETAIL_SUCCESS';
export const GET_RENTAL_PACKAGE_SETUP_DETAIL_ERROR = 'GET_RENTAL_PACKAGE_SETUP_DETAIL_ERROR';

export const CREATE_RENTAL_PACKAGE_SETUP_REQUEST = 'CREATE_RENTAL_PACKAGE_SETUP_REQUEST';
export const CREATE_RENTAL_PACKAGE_SETUP_SUCCESS = 'CREATE_RENTAL_PACKAGE_SETUP_SUCCESS';
export const CREATE_RENTAL_PACKAGE_SETUP_ERROR = 'CREATE_RENTAL_PACKAGE_SETUP_ERROR';

export const UPDATE_RENTAL_PACKAGE_SETUP_REQUEST = 'UPDATE_RENTAL_PACKAGE_SETUP_REQUEST';
export const UPDATE_RENTAL_PACKAGE_SETUP_SUCCESS = 'UPDATE_RENTAL_PACKAGE_SETUP_SUCCESS';
export const UPDATE_RENTAL_PACKAGE_SETUP_ERROR = 'UPDATE_RENTAL_PACKAGE_SETUP_ERROR';

export const UPDATE_CONTRACT_REQUEST = 'UPDATE_CONTRACT_REQUEST';
export const UPDATE_CONTRACT_SUCCESS = 'UPDATE_CONTRACT_SUCCESS';
export const UPDATE_CONTRACT_ERROR = 'UPDATE_CONTRACT_ERROR';

export const DELETE_RENTAL_PACKAGE_SETUP_REQUEST = 'DELETE_RENTAL_PACKAGE_SETUP_REQUEST';
export const DELETE_RENTAL_PACKAGE_SETUP_SUCCESS = 'DELETE_RENTAL_PACKAGE_SETUP_SUCCESS';
export const DELETE_RENTAL_PACKAGE_SETUP_ERROR = 'DELETE_RENTAL_PACKAGE_SETUP_ERROR';

export const CREATE_CONTRACT_REQUEST = 'CREATE_CONTRACT_REQUEST';
export const CREATE_CONTRACT_SUCCESS = 'CREATE_CONTRACT_SUCCESS';
export const CREATE_CONTRACT_ERROR = 'CREATE_CONTRACT_ERROR';

export const GET_CONTRACT_DETAIL_REQUEST = 'GET_CONTRACT_DETAIL_REQUEST';
export const GET_CONTRACT_DETAIL_SUCCESS = 'GET_CONTRACT_DETAIL_SUCCESS';
export const GET_CONTRACT_DETAIL_ERROR = 'GET_CONTRACT_DETAIL_ERROR';

export const DELETE_CONTRACT_REQUEST = 'DELETE_CONTRACT_REQUEST';
export const DELETE_CONTRACT_SUCCESS = 'DELETE_CONTRACT_SUCCESS';
export const DELETE_CONTRACT_ERROR = 'DELETE_CONTRACT_ERROR';

export const FETCH_CONTRACT_REQUEST = 'FETCH_CONTRACT_REQUEST';
export const FETCH_CONTRACT_SUCCESS = 'FETCH_CONTRACT_SUCCESS';
export const FETCH_CONTRACT_ERROR = 'FETCH_CONTRACT_ERROR';

export const FETCH_CONTRACT_OPTIONS_REQUEST = "FETCH_CONTRACT_OPTIONS_REQUEST";
export const FETCH_CONTRACT_OPTIONS_SUCCESS = "FETCH_CONTRACT_OPTIONS_SUCCESS";
export const FETCH_CONTRACT_OPTIONS_ERROR = "FETCH_CONTRACT_OPTIONS_ERROR";

export const GENERATE_RECURRING_INVOICE_REQUEST = 'GENERATE_RECURRING_INVOICE_REQUEST';
export const GENERATE_RECURRING_INVOICE_SUCCESS = 'GENERATE_RECURRING_INVOICE_SUCCESS';
export const GENERATE_RECURRING_INVOICE_ERROR = 'GENERATE_RECURRING_INVOICE_ERROR';

export const TERMINATE_CONTRACT_REQUEST = 'TERMINATE_CONTRACT_REQUEST';
export const TERMINATE_CONTRACT_SUCCESS = 'TERMINATE_CONTRACT_SUCCESS';
export const TERMINATE_CONTRACT_ERROR = 'TERMINATE_CONTRACT_ERROR';

export const EXPORT_EXCEL_REQUEST = 'EXPORT_EXCEL_REQUEST';
export const EXPORT_EXCEL_SUCCESS = 'EXPORT_EXCEL_SUCCESS';
export const EXPORT_EXCEL_ERROR = 'EXPORT_EXCEL_ERROR';

export const fetchContract = data => dispatch => {

  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_CONTRACT_REQUEST, FETCH_CONTRACT_SUCCESS, FETCH_CONTRACT_ERROR],
      callAPI: () => ApiClient.post('payment/Contracts/Search', data),
      payload: { data },
    }),
  );
};

export const terminateContract = (id) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        TERMINATE_CONTRACT_REQUEST,
        TERMINATE_CONTRACT_SUCCESS,
        TERMINATE_CONTRACT_ERROR,
      ],
      callAPI: () => ApiClient.put(`payment/Contracts/Terminate/${id}`),
      payload: { data: { id } },
    }),
  );
};


export const fetchContractOptions = (customerId) => (dispatch) => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_CONTRACT_OPTIONS_REQUEST,
        FETCH_CONTRACT_OPTIONS_SUCCESS,
        FETCH_CONTRACT_OPTIONS_ERROR,
      ],
      callAPI: () => ApiClient.get(`payment/Contracts/GetSelectList?customerId=${customerId}`),
      payload: {},
    }),
  );
};

export const createContract = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [CREATE_CONTRACT_REQUEST, CREATE_CONTRACT_SUCCESS, CREATE_CONTRACT_ERROR],
      callAPI: () => ApiClient.post('payment/Contracts/Create', data),
      payload: { data, formId },
    }),
  );
};


export const getContractDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [GET_CONTRACT_DETAIL_REQUEST, GET_CONTRACT_DETAIL_SUCCESS, GET_CONTRACT_DETAIL_ERROR],
      callAPI: () => ApiClient.get(`payment/Contracts/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};



export const deleteContractLevel = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_CONTRACT_REQUEST, DELETE_CONTRACT_SUCCESS, DELETE_CONTRACT_ERROR],
      callAPI: () => ApiClient.delete(`payment/Contracts/${id}`),
      payload: { data: { id } },
    }),
  );
};




export const fetchRentalPackageSetup = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_RENTAL_PACKAGE_SETUPS_REQUEST,
        FETCH_RENTAL_PACKAGE_SETUPS_SUCCESS,
        FETCH_RENTAL_PACKAGE_SETUPS_ERROR,
      ],
      callAPI: () => ApiClient.post('payment/RentalPackageSetup/Search', data),
      payload: { data },
    }),
  );
};

export const fetchRentalPackageSetupOptions = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST,
        FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS,
        FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR,
      ],
      callAPI: () => ApiClient.get('payment/RentalPackageSetup/GetSelectList'),
      payload: {},
    }),
  );
};

export const fetchEntityRentalPackageSetupOptions = entity => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST,
        FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS,
        FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR,
      ],
      callAPI: () =>
        ApiClient.get(`payment/RentalPackageSetup/GetOptionsByEntity/${entity}`),
      payload: { data: { entity } },
    }),
  );
};

export const getRentalPackageSetupDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_RENTAL_PACKAGE_SETUP_DETAIL_REQUEST,
        GET_RENTAL_PACKAGE_SETUP_DETAIL_SUCCESS,
        GET_RENTAL_PACKAGE_SETUP_DETAIL_ERROR,
      ],
      callAPI: () => ApiClient.get(`payment/RentalPackageSetup/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const createRentalPackageSetup = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        CREATE_RENTAL_PACKAGE_SETUP_REQUEST,
        CREATE_RENTAL_PACKAGE_SETUP_SUCCESS,
        CREATE_RENTAL_PACKAGE_SETUP_ERROR,
      ],
      callAPI: () => ApiClient.post('payment/RentalPackageSetup', data),
      payload: { data, formId },
    }),
  );
};

export const updateRentalPackageSetup = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        UPDATE_RENTAL_PACKAGE_SETUP_REQUEST,
        UPDATE_RENTAL_PACKAGE_SETUP_SUCCESS,
        UPDATE_RENTAL_PACKAGE_SETUP_ERROR,
      ],
      callAPI: () => ApiClient.put(`payment/RentalPackageSetup/${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const updateContract = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        UPDATE_CONTRACT_REQUEST,
        UPDATE_CONTRACT_SUCCESS,
        UPDATE_CONTRACT_ERROR,
      ],
      callAPI: () => ApiClient.put(`payment/Contracts/${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const updateContractSerialNumber = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        UPDATE_CONTRACT_REQUEST,
        UPDATE_CONTRACT_SUCCESS,
        UPDATE_CONTRACT_ERROR,
      ],
      callAPI: () => ApiClient.put(`Contracts/${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const deleteRentalPackageSetup = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        DELETE_RENTAL_PACKAGE_SETUP_REQUEST,
        DELETE_RENTAL_PACKAGE_SETUP_SUCCESS,
        DELETE_RENTAL_PACKAGE_SETUP_ERROR,
      ],
      callAPI: () => ApiClient.delete(`payment/RentalPackageSetup/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const generateRecurringInvoice = (data) => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_RECURRING_INVOICE_REQUEST,
        GENERATE_RECURRING_INVOICE_SUCCESS,
        GENERATE_RECURRING_INVOICE_ERROR,
      ],
      callAPI: () => ApiClient.post(`payment/Contracts/GenerateRecurringInvoice`, data),
      payload: { data },
    }),
  );
};

export const generateScheduleRental = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_RECURRING_INVOICE_REQUEST,
        GENERATE_RECURRING_INVOICE_SUCCESS,
        GENERATE_RECURRING_INVOICE_ERROR,
      ],
      callAPI: () => ApiClient.post(`payment/Contracts/GenerateScheduleRental/${id}`),
      payload: { id },
    }),
  );
};

export const updateContractRentalPeriod = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [
        UPDATE_CONTRACT_REQUEST,
        UPDATE_CONTRACT_SUCCESS,
        UPDATE_CONTRACT_ERROR,
      ],
      callAPI: () => ApiClient.put(`payment/Contracts/UpdateRentalPeriod/${id}`, data),
      payload: { data: { ...data, id }, formId },
    }),
  );
};

export const exportExcel = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [EXPORT_EXCEL_REQUEST, EXPORT_EXCEL_SUCCESS, EXPORT_EXCEL_ERROR],
      callAPI: () => ApiClient.post('payment/Contracts/ExportExcel', data, {
        responseType: 'blob'
      }),
      payload: { data }
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_RENTAL_PACKAGE_SETUPS_REQUEST:
    case FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST:
    case FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_REQUEST:
    case GET_RENTAL_PACKAGE_SETUP_DETAIL_REQUEST:
    case CREATE_RENTAL_PACKAGE_SETUP_REQUEST:
    case UPDATE_RENTAL_PACKAGE_SETUP_REQUEST:
    case UPDATE_CONTRACT_REQUEST:
    case DELETE_RENTAL_PACKAGE_SETUP_REQUEST:
    case FETCH_CONTRACT_OPTIONS_REQUEST:
    case FETCH_CONTRACT_REQUEST:
    case GET_CONTRACT_DETAIL_REQUEST:
    case CREATE_CONTRACT_REQUEST:
    case DELETE_CONTRACT_REQUEST:
    case EXPORT_EXCEL_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_RENTAL_PACKAGE_SETUPS_SUCCESS:
    case FETCH_CONTRACT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };
    case FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS:
    case FETCH_CONTRACT_OPTIONS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          options: response.data.data,
        },
        response,
        successMessage,
      };

    case FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          entityRentalPackageSetupOptions: {
            ...state.data.entityRentalPackageSetupOptions,
            [payload.data.entity + 'RentalPackageSetupOptions']: response.data.data,
          },
        },
        response,
        successMessage,
      };

    case GET_RENTAL_PACKAGE_SETUP_DETAIL_SUCCESS:
    case GET_CONTRACT_DETAIL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };


    case CREATE_CONTRACT_SUCCESS:
    case DELETE_CONTRACT_SUCCESS:
    case CREATE_RENTAL_PACKAGE_SETUP_SUCCESS:
    case UPDATE_RENTAL_PACKAGE_SETUP_SUCCESS:
    case UPDATE_CONTRACT_SUCCESS:
    case DELETE_RENTAL_PACKAGE_SETUP_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };

    case EXPORT_EXCEL_SUCCESS:
      return {
        ...state,
        blob: response.data,
        successMessage: 'Excel file exported successfully',
      };

    case FETCH_RENTAL_PACKAGE_SETUPS_ERROR:
    case FETCH_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR:
    case FETCH_ENTITY_RENTAL_PACKAGE_SETUP_OPTIONS_ERROR:
    case GET_RENTAL_PACKAGE_SETUP_DETAIL_ERROR:
    case CREATE_RENTAL_PACKAGE_SETUP_ERROR:
    case UPDATE_RENTAL_PACKAGE_SETUP_ERROR:
    case UPDATE_CONTRACT_ERROR:
    case DELETE_RENTAL_PACKAGE_SETUP_ERROR:
    case FETCH_CONTRACT_OPTIONS_ERROR:
    case FETCH_CONTRACT_ERROR:
    case GET_CONTRACT_DETAIL_ERROR:
    case CREATE_CONTRACT_ERROR:
    case DELETE_CONTRACT_ERROR:
    case EXPORT_EXCEL_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
